import { Dimensions, Platform, StyleSheet } from 'react-native'
import {
  Colors,
  Fonts
} from '@vfgroup-oneplatform/foundation/Components/Themes'

const styles = StyleSheet.create({
  flex: {
    flex: 1
  },
  white: {
    color: Colors.white
  },
  header: {
    paddingTop: Platform.OS === 'android' ? 4 : 0
  },
  inner: { flex: 1, justifyContent: 'flex-end' },
  stepper: {
    marginTop: 0,
    paddingTop: 16,
    marginBottom: 0,
    paddingBottom: 12,
    paddingHorizontal: 12
  },
  scrollView: {
    width: 475
  },
  timelineOuter: theme => ({
    borderBottomWidth: 1,
    borderBottomColor: Colors.lightGrey,
    backgroundColor: theme.colors.cardBackgroundColor,
  }),
  screenWrapper: (step, install) => {
    const idx = install ? 3 : 2
    return {
      flex: 1,
      paddingHorizontal: step >= idx ? 0 : 16
    }
  },
  contentContainer: theme => ({
    flex: 1,
    backgroundColor: theme.colors.backgroundColorTwo,
    paddingHorizontal: Platform.OS === 'web' && Dimensions.get('window').width > 700 ? '10%' : 0
  }),
  subHeaderTitle: {
    marginTop: 32,
    lineHeight: 32,
    color: Colors.white
  },
  timelineContainer: theme => ({
    flex: 1,
    backgroundColor: theme.colors.cardBackgroundColor,
    width: '100%'
  }),
  timelineIconContainer: {
    marginBottom: 4
  },
  timelineItemTitle: {
    padding: 0,
    fontSize: 16
  },
  timelineActiveItemTitle: theme => ({
    color: theme.colors.textColor
  }),
  titleText: {
    marginTop: 40,
    color: Colors.white,
    fontSize: Fonts.size.h4
  },
  subtitleText: {
    color: Colors.white,
    fontSize: Fonts.size.h5
  },
  subHeaderAfterSubTitleStyle: {
    marginBottom: -3,
    color: Colors.white
  },
  detailsBtn: {
    color: Colors.white,
    flexDirection: 'row',
    alignItems: 'center'
  },
  detailsBtnIcon: {
    marginLeft: 5,
    tintColor: Colors.vfRed
  },
  screenHeader: {
    backgroundColor: Colors.vfRed
  },
  screenTitle: {
    color: Colors.white
  },
  viewDetailText: {
    color: Colors.white,
    fontFamily: Fonts.type.VFFont,
    fontSize: Fonts.size.regularSmall
  },
  descriptionText: {
    color: Colors.white,
    fontSize: Fonts.size.h1,
    fontFamily: Fonts.type.VFFont
  },
  headerBg: theme => ({
    backgroundColor: theme.colors.backgroundColor
  }),
  viewMoreBtn: {
    color: Colors.vfRed
  },
  headerTitle: {
    flex: 1,
    height: '100%',
    paddingBottom: 0,
    maxHeight: 'auto',
    paddingTop: Platform.OS === 'android' ? 26 : 12
  },
  headerDescription: w => {
    return {
      flex: 1,
      width: w - 32,
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between'
    }
  },
  viewBtnHolder: {
    fontSize: 12,
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'row'
  },
  days: {
    paddingTop: 14,
    paddingBottom: 12
  },
  count: {
    fontSize: 24,
    fontWeight: 'bold'
  },
  offerEnd: {
    fontSize: 18
  },
  endDesc: {
    fontSize: 14,
    lineHeight: 18
  },
  viewBtnIcon: {
    marginLeft: 8
  },
  headerStyle: {
    marginLeft: 0,
    marginRight: 0,
    paddingBottom: 16
  },
  label: {
    fontSize: 16
  },
  save: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'row'
  },
  saveAmount: {
    fontSize: 16,
    paddingLeft: 8,
    color: Colors.vfRed
  },
  amount: {
    fontSize: 20,
    fontWeight: 'bold'
  },
  monthly: {
    fontSize: 20
  },
  mainTitle: {
    fontSize: 24,
    paddingBottom: 12
  },
  topSpace: {
    paddingTop: 16
  }
})

export default styles
